// extracted by mini-css-extract-plugin
export var formContainer = "_kq-0";
export var message = "_kq-1";